import React from 'react';

const NoUser = (props) => (
  <svg width="50px" height="50px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="35" cy="7" r="5" fill="#9B8AFC" />
    <circle cx="13" cy="9" r="6" fill="#9B8AFC" />
    <circle cx="24.5" cy="14.5" r="9" fill="#9B8AFC" stroke="#F9FAFB" strokeWidth="3" />
    <path
      d="M17.1638 23.034C15.5133 21.8464 14.4273 19.4004 14.0997 17.8372C13.9988 17.3561 13.6376 16.9326 13.149 16.878C4.31945 15.8907 1.51338 22.1226 1.99805 26C1.99805 27.9057 3.81568 29.8123 7.8774 29.9858C8.25564 30.002 8.59929 29.7819 8.79433 29.4574C10.7025 26.2829 14.7103 24.4762 17.0752 23.7495C17.3561 23.6632 17.4023 23.2057 17.1638 23.034Z"
      fill="#D9D6FE"
    />
    <path
      d="M38.2012 17.2931L32.6571 22.8401C31.983 23.5145 31.7083 23.7969 32.5883 24.1639C34.4337 24.9337 37.7703 26.8264 39.2425 29.4947C39.4118 29.8016 39.7078 30.031 40.0576 30.0539C43.7309 30.2941 45.9941 28.1898 45.9941 24C45.9941 19.8301 41.5069 17.2769 38.9063 17.0212C38.6423 16.9953 38.3887 17.1054 38.2012 17.2931Z"
      fill="#D9D6FE"
    />
    <path d="M10.998 36.4952L20.998 26.9987C15.0006 24.4997 9.00098 33 10.498 36.9952L10.998 36.4952Z" fill="#D9D6FE" />
    <path
      d="M28.2358 27.2642L12.8904 42.6096C12.5703 42.9297 12.8037 43.4812 13.2563 43.4769C19.4298 43.4179 31.1558 43.961 33 43.5C35 43 36.6667 41.8333 37 41C40.2671 31.1988 32.8604 27.7351 30.0364 26.7949C29.3966 26.5818 28.7127 26.7873 28.2358 27.2642Z"
      fill="#D9D6FE"
    />
    <rect
      x="0.53125"
      y="45.1875"
      width="63.008"
      height="3"
      rx="1.5"
      transform="rotate(-45.235 0.53125 45.1875)"
      fill="#667085"
    />
  </svg>
);
export default NoUser;
